import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'osn-cxb-limited-text-input',
  templateUrl: './limited-text-input.component.html',
  styleUrls: ['./limited-text-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LimitedTextInputComponent),
      multi: true,
    },
  ],
})
export class LimitedTextInputComponent implements ControlValueAccessor {
  @Input() public multiline: boolean;
  @Input() public label: string;
  @Input() public placeholder: string;
  @Input() public maxLength: number;
  @Input() public readonly: boolean;
  @Input() public textDirection = 'ltr';
  //eslint-disable-next-line
  @Input('data-testid') public testId?: string;

  public value: string;
  public isDisabled: boolean;
  public propagateChange: Function = () => {};
  public onTouched: Function = () => {};

  constructor(private readonly chRef: ChangeDetectorRef) {}

  public registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    this.chRef.detectChanges();
  }

  public writeValue(value: string): void {
    this.value = value;
    this.chRef.detectChanges();
  }
}
